'use client';

import { useState, useEffect }  from 'react';
import { reviewAPI } from '../services/api';
import Link from 'next/link';

// const testimonials = [
//   {
//     id: 1,
//     quote: "A good bus service is essential for efficient public transportation, contributing to a well-connected community and quality of life in a community, so...",
//     name: "Henry James",
//     title: "Amazing Service",
//     avatar: "/images/avatar1.jpg",
//   },
//   {
//     id: 2,
//     quote: "A good bus service is essential for efficient public transportation, contributing to a well-connected community and quality of life in a community, so...",
//     name: "Rayed Miah",
//     title: "Amazing Service",
//     avatar: "/images/avatar2.jpg",
//   },
//   {
//     id: 3,
//     quote: "A good bus service is essential for efficient public transportation, contributing to a well-connected community and quality of life in a community, so...",
//     name: "Masudur Rahman",
//     title: "Amazing Service",
//     avatar: "/images/avatar3.jpg",
//   },
// ];

const CustomerFeedback = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await reviewAPI.getAllReviewsHome(6);
      const testimonialData = response.data || [];
      setTestimonials(testimonialData);
      setVisible(testimonialData.length > 0);
    } catch (err) {
      console.error('Error fetching testimonials:', err);
      setError('Failed to load testimonials');
      setTestimonials([]);
      setVisible(false);
    } finally {
      setLoading(false);
    }
  };
  // Add styles to the document head
  useEffect(() => {
    const styles = `
      @keyframes feedbackScroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      
      .animate-feedback-scroll {
        display: inline-block;
        animation: feedbackScroll 40s linear infinite;
      }
      
      .animate-feedback-scroll:hover {
        animation-play-state: paused;
      }
      
      .hide-scrollbar {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
    `;
    
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.id = 'customer-feedback-styles';
    styleSheet.innerHTML = styles;
    
    document.head.appendChild(styleSheet);
    
    // Cleanup function
    return () => {
      const existingStyle = document.getElementById('customer-feedback-styles');
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
    };
  }, []);

  const renderStars = (rating) => {
    return (
      <div className="flex">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-4 h-4 ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    );
  };

  const getAvatarSrc = (review) => {
    debugger;
        if (review.reviewerImage) {
            return review.reviewerImage.startsWith('http')
                ? review.reviewerImage
                : `${reviewAPI.baseUrl.replace('/api', '')}/${review.reviewerImage}`;
        }
        if (review.User?.avatar) return review.User.avatar;
        return null;
    };
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-4">Customer Feedback</h2>
        <p className="text-base md:text-lg text-gray-600 mb-16">Real feedback from our customers to help us improve our services</p>
  
        <div className="px-4 md:px-8">
          <div className="overflow-hidden hide-scrollbar">
            <div className="relative w-full overflow-hidden py-6">
              <div className="animate-feedback-scroll">
                <div className="inline-flex space-x-6">
                  {[...testimonials].map((testimonial, index) => (
                    <div key={`feedback-${index}`} className="flex-shrink-0 w-96 px-3">
                      <div className="bg-white p-8 md:p-10 rounded-xl shadow-lg min-h-64 flex flex-col justify-between mx-1">
                        <p className="text-gray-600 mb-6 text-base md:text-lg flex-grow break-words">" {testimonial.comment} "</p>
                        <div className="flex items-center pt-4">
                          <img 
                            // src={getAvatarSrc(testimonial)} 
                            src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${testimonial.reviewerImage}`}
                            alt={testimonial.reviewerName} 
                            className="w-12 h-12 md:w-14 md:h-14 rounded-full mr-4 md:mr-5" 
                            // onError={(e) => {
                            //   e.target.src = '/images/placeholder-avatar.png';
                            // }}
                          />
                          <div className="text-left">
                            <h4 className="text-lg md:text-xl font-semibold text-gray-800"><Link href={`${testimonial.permalink}`}>{testimonial.reviewerName}</Link></h4>
                            <div className="mt-1">
                              {renderStars(testimonial.rating)}
                            </div>
                            {/* <p className="text-gray-500 text-base md:text-lg">{testimonial.message}</p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerFeedback;